import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/app/AuthContext";
import { Landing } from "@/app/Landing";
import { AppShell } from "@/app/AppShell";
import { ProtectedRoute } from "@/app/ProtectedRoute";
import { EventsPage } from "@/app/EventsPage";
import { EventDetailPage } from "@/app/EventDetailPage";
import { MixesPage } from "@/app/MixesPage";
import { GalleryPage } from "@/app/GalleryPage";
import { TicketsPage } from "@/app/TicketsPage";
import { OrganizerPage } from "@/app/OrganizerPage";
import { ScanPage } from "@/app/ScanPage";
import { LoginPage, RegisterPage } from "@/app/AuthPages";
import { PaymentSuccess, PaymentCancel } from "@/app/PaymentPages";

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/register" element={<RegisterPage />} />
          <Route path="/payment/success" element={<PaymentSuccess />} />
          <Route path="/payment/cancel" element={<PaymentCancel />} />
          <Route element={<AppShell />}>
            <Route path="/events" element={<EventsPage />} />
            <Route path="/events/:id" element={<EventDetailPage />} />
            <Route path="/mixes" element={<MixesPage />} />
            <Route path="/gallery" element={<GalleryPage />} />
            <Route path="/tickets" element={<TicketsPage />} />
            <Route path="/organizer" element={<ProtectedRoute organizerOnly><OrganizerPage /></ProtectedRoute>} />
            <Route path="/scan" element={<ProtectedRoute organizerOnly><ScanPage /></ProtectedRoute>} />
          </Route>
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
